import { useId } from 'react';

// Inline SVG flags (emoji flags don't render on Windows). Decorative: the
// language name is always next to it or in the button's label.
export const Flag = ({ lang, className = 'h-4 w-6' }) => {
  const id = useId().replace(/:/g, '');
  const common = {
    className: `${className} flex-none overflow-hidden rounded-[3px] ring-1 ring-candy-ink/15`,
    'aria-hidden': 'true',
    focusable: 'false',
  };

  if (lang === 'ru') {
    return (
      <svg viewBox="0 0 9 6" {...common}>
        <rect width="9" height="2" fill="#FFFFFF" />
        <rect y="2" width="9" height="2" fill="#0039A6" />
        <rect y="4" width="9" height="2" fill="#D52B1E" />
      </svg>
    );
  }

  if (lang === 'it') {
    return (
      <svg viewBox="0 0 3 2" {...common}>
        <rect width="1" height="2" fill="#009246" />
        <rect x="1" width="1" height="2" fill="#FFFFFF" />
        <rect x="2" width="1" height="2" fill="#CE2B37" />
      </svg>
    );
  }

  // English: Union Jack
  return (
    <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" {...common}>
      <clipPath id={`${id}-t`}>
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" clipPath={`url(#${id}-t)`} stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 v30 M0,15 h60" stroke="#FFFFFF" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
};
